import styles from '../styles/components/BookingFlowInfrared.module.scss'
import ArrowExpandIcon from '../assets/icons/arrow-expand.svg'
import { Service } from '../types/bookings'
import { useEffect, useState } from 'react';
import ActiveSelectIcon from '../assets/icons/active-select-filled.svg';
import InactiveSelectIcon from '../assets/icons/inactive-select.svg';
import WarningIcon from '../assets/icons/warning.svg';
interface Props {
  services: Service[];
  onSelectInfrared: (service: Service | undefined, string: string | null | undefined) => void;
  prevSelectedInfrared?: Service;
  prevSelectedIrSequence?: string;
}

export const BookingFlowInfrared:React.FC<Props> = ({
  services,
  onSelectInfrared,
  prevSelectedInfrared,
  prevSelectedIrSequence,
}) => {
  const [showInfraredBenefits, setShowInfraredBenefits] = useState<string | number>('')
  const [selectedInfrared, setSelectedInfrared] = useState<Service | undefined | null>(prevSelectedInfrared)
  const [selectedRadioValue, setSelectedRadioValue] = useState<string | undefined | null>(prevSelectedIrSequence);
  const filteredServices = services.filter(s => s.specialService === 'infrared')

  const handleSelectInfrared = (infrared: Service) => {
    if (infrared === selectedInfrared) {
      setSelectedInfrared(undefined)
      setSelectedRadioValue(undefined)
      onSelectInfrared(undefined, undefined)
    } else {
      setSelectedInfrared(infrared)
      if (!selectedRadioValue) {
        setSelectedRadioValue(getInfraredSequenceOptions()[0].value)
      }
    }
  }

  const handleShowBenefits = (event: React.MouseEvent, serviceId: string | number) => {
    event.stopPropagation()
    setShowInfraredBenefits(serviceId === showInfraredBenefits ? '' : serviceId)
  }

  const handleOptionChange = (value: string) => {
    setSelectedRadioValue(value)
  }

  const getInfraredSequenceOptions = () => {
    return [
      {
        label: 'Before Massage',
        value: "before"
      },
      {
        label: 'After Massage',
        value: "after"
      }
    ]
  }

  useEffect(() => {
    selectedInfrared && selectedRadioValue && onSelectInfrared(selectedInfrared, selectedRadioValue)
  }, [selectedInfrared, selectedRadioValue])

  return (
    <div>
      <div className={styles.selectInfrared}>
        {filteredServices.map((service) => {
          return (
            <div
              className={`${styles.infrared} ${selectedInfrared?.id === service.id ? styles.selected : ''}`}
              key={service.id}
              onClick={() => handleSelectInfrared(service)}
            >
              <div className={styles.header}>
                <p className={styles.title}>{service.name}</p>
                <p className={styles.price}>${service.salePrice}</p>
              </div>
              <p className={`${styles.description} ${showInfraredBenefits === service.id ? styles.showFullDescription : ''}`}>{service.description}</p>
              {service.meta.benefits && (
                <>
                  {showInfraredBenefits === service.id && (
                    <div>
                      <p className={styles.benefitsTitle}>Benefits:</p>
                      <p className={styles.benefitsDetails}>{service.meta.benefits}</p>
                    </div>
                  )}
                  <button className={`${styles.arrowButton} ${showInfraredBenefits === service.id ? styles.active : ""}`} onClick={(e) => handleShowBenefits(e, service.id)}>
                    <img src={ArrowExpandIcon} alt="expand info" />
                  </button>
                </>
              )}
            <div className={styles.memberPrice}>
              Members Pay ${service.memberPrice}
            </div>
            </div>
          )
        })}
      </div>
      <p className={styles.radioGroupTitle}>Select An Option:</p>
      <div className={`${styles.radioBoxContainer} ${!selectedInfrared ? styles.disabled : ''}`}>
        {getInfraredSequenceOptions().map((option) => (
          <div key={option.value} className={`${styles.input} ${selectedRadioValue === option.value ? styles.selected : ''}`}>
            <input
              type="radio"
              id={`infrared-${option.value}`}
              value={option.value}
              checked={selectedRadioValue === option.value}
              onChange={() => handleOptionChange(option.value)}
              className={styles.radioInput}
              disabled={!selectedInfrared}
            />
            <label htmlFor={`infrared-${option.value}`} className={styles.radioLabel}>
              <span>{option.label}</span>
              <img
                src={
                  selectedRadioValue === option.value
                    ? ActiveSelectIcon
                    : InactiveSelectIcon
                }
                alt={selectedRadioValue === option.value ? 'Selected' : 'Not Selected'}
                className={styles.radioIcon}
              />
            </label>
          </div>
        ))}
      </div>
      <div className={styles.disclaimer}>
        <img src={WarningIcon} alt="warning" />
        <p>Infrared Sauna is not recommended for minors, those who are pregnant, those who have sensitivities to heat, or after receiving Gua Sha or Gliding Cupping.</p>
      </div>
      <div className={styles.membershipInfo}>
        <h3>Elevate Your Experience with a Membership</h3>
        <p>Enjoy savings on Infrared Sauna by becoming a Member at checkout.</p>
      </div>
    </div>
  )
}
